<template>
    <div></div>
</template>
<script>
export default {
    name: "AccountLogOut",
    mounted() {
        if(localStorage.getItem('ownerAccessToken')) {
            localStorage.setItem('accessToken', localStorage.getItem('ownerAccessToken'))
            localStorage.removeItem('ownerAccessToken')
            window.location.href = '/';
        }else {
            this.$store.dispatch('auth/logout')
            .then(() => {
                this.$router.go('/login')
            })
        }
    }
}
</script>